import { ReactElement, ReactNode } from "react";
export const VEHICLES_LOADING = "VEHICLES_LOADING";
export const VEHICLES_FAILURE = "VEHICLES_FAILURE";
export const VEHICLES_SUCCESS = "VEHICLES_SUCCESS";

export type Vehicles = {
  id: string;
  AssetNumber: string;
  values: Array<VehicleData>;
  Location: string;
};

export type VehicleData = {
  Date: string;
  DeviceName: string;
  StealthBatteryAmps: number;
  StealthBatteryVolts: number;
  SolarAmps: number;
  ShorelineVolts: number;
  SystemTemperature: number;
  StateOfCharge: number;
  OEMBatteryVoltage: number;
  FuelLevel: number;
  BMSMaxCellVolts: number;
  RSSI: number;
  BMSPackVolts: number;
  SystemState: number;
  Odometer: number;
  MastAmps: number;
  TiltAngle: number;
  MastEmergencyStop: boolean;
  TiltControl: boolean;
  MastControl: boolean;
  MoveUp: boolean;
  MoveDown: boolean;
  Tilt0: boolean;
  Tilt90: boolean;
  MastNested: boolean;
  MastExtended: boolean;
  TiltLock: boolean;
  MastHeight: number;
  MastCycles: number;
  TiltCycles: number;
};

export interface VehicleLoading {
  type: typeof VEHICLES_LOADING;
}

export interface VehicleFailure {
  type: typeof VEHICLES_FAILURE;
}

export interface VehicleSuccess {
  type: typeof VEHICLES_SUCCESS;
  payload: Array<Vehicles>;
}

export type VehicleDispatchTypes =
  | VehicleLoading
  | VehicleFailure
  | VehicleSuccess;
